module.exports = __webpack_public_path__ + "static/software-ff34bd9eee709df430b1850437eeb35d.jpg";